import { IDmGioiTinhActionTypes } from "../../action-types/category/IDmGioiTinhActions";
import { IDmGioiTinhReducer } from "../../reducer-model/category/IDmGioiTinhReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IDmGioiTinhReducer = {
  status: eReducerStatusBase.is_not_initialization,
  gioiTinhs: [],
};
export const gioiTinhReducer = (
  state: IDmGioiTinhReducer = iniState,
  action: IDmGioiTinhActionTypes
): IDmGioiTinhReducer => {
  switch (action.type) {
    case "GIOI_TINH_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "GIOI_TINH_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        gioiTinhs: action.payload,
      };
    case "GIOI_TINH_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
